import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';

@Injectable({ providedIn: 'root' })
export class AppLogsFirebaseService {
  constructor(private afs: AngularFirestore) {}

  /** Grava um log informativo; nunca lança, para não interromper o fluxo que o chamou. */
  async info(message: string, context: string, data: Record<string, unknown> = {}): Promise<void> {
    try {
      const log: Record<string, unknown> = {
        type: 'info',
        message,
        context,
        timestamp: new Date().toISOString(),
        userAgent: navigator.userAgent,
        url: location.href,
        environment: location.hostname === 'localhost' ? 'development' : 'production',
        ...data,
      };

      Object.keys(log).forEach(key => log[key] === undefined && delete log[key]);

      await this.afs.collection('AppLogs').add(log);
    } catch (error) {
      console.error(`[app-logs] falha ao salvar log (${context}):`, error);
    }
  }
}
